<mat-table
  [dataSource]="rows"
  matSort
  matSortDisableClear
  (matSortChange)="sortData($event)"
  matSortActive="progress"
  matSortDirection="asc"
>
  <ng-container matColumnDef="code">
    <mat-header-cell *matHeaderCellDef mat-sort-header="code">code</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.code }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="coach">
    <mat-header-cell *matHeaderCellDef mat-sort-header="coach">coach</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.coach || '-' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="progress">
    <mat-header-cell *matHeaderCellDef mat-sort-header="progress">progress</mat-header-cell>
    <mat-cell *matCellDef="let element" [class]="element.status.code === inProgressStatus ? 'fl-column-cell' : ''">
      @if (element.status.code === inProgressStatus) {
        <mat-progress-bar
          mode="determinate"
          [value]="(100 * getWeeksRunning(element)) / element.maxRunningTime"
        ></mat-progress-bar>
        <span>{{ getWeeksRunning(element) }} / {{ element.maxRunningTime }}</span>
      } @else {
        {{ element.status.description }}
      }
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="numberOfRounds">
    <mat-header-cell *matHeaderCellDef mat-sort-header="numberOfRounds">#rounds</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.numberOfRounds || 0 }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="nextTask">
    <mat-header-cell *matHeaderCellDef mat-sort-header="nextTask">next task</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.nextTask?.title || '-' }}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="['/beneficiarygroups', row.uuid]"></mat-row>
</mat-table>
